import React from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
  FormFeedback,
} from "reactstrap"

import { useDispatch, useSelector } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import LoadingComponent from "components/Loading/LoadingComponent"
import { useFormik } from "formik"
import * as Yup from "yup"
import { MetaTags } from "react-meta-tags"
import DimensionAction from "store/dimension-resource/actions"
import Select from "react-select"

export default function DetailDimension() {
  const dispatch = useDispatch()
  const params = useParams()
  const history = useHistory()
  const store = useSelector(state => state)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      categoryName: "",
      item: "",
      format: "TEXT",
      frameType: "",
    },
    validationSchema: Yup.object({
      categoryName: Yup.string().required("商品カテゴリー 必須項目です。"),
      item: Yup.string().required("項目 必須項目です。"),
      format: Yup.string().required("形式 必須項目です。"),
      frameType: Yup.string().required("枠種類 必須項目です。"),
    }),
    onSubmit: values => {
      if (params.id === "add") {
        dispatch(DimensionAction.postData(values, callbackPost))
      } else {
        dispatch(
          DimensionAction.putData({ ...values, id: params.id }, callbackPut)
        )
      }
    },
  })

  const callbackPost = (isSuccess = true, errors) => {
    if (isSuccess) {
      history.push("/master/dimension")
      validation.resetForm()
    } else {
      console.log(errors, "errors")
      validation.setErrors(errors)
    }
  }

  const callbackPut = (isSuccess = true, errors) => {
    if (isSuccess) {
      history.push("/master/dimension")
      validation.resetForm()
    } else {
      console.log(errors, "errors")
      validation.setErrors(errors)
    }
  }

  const callbackGetDetail = data => {
    validation.setValues(data)
  }

  React.useEffect(() => {
    if (params.id !== "add") {
      dispatch(DimensionAction.getDetail({ id: params.id }, callbackGetDetail))
    }
  }, [params.id])

  React.useEffect(() => {
    dispatch(DimensionAction.getListDimensionCategory())
    dispatch(DimensionAction.getListFrameType())
  }, [])

  return (
    <>
      <MetaTags>
        <title>個人顧客管理 | Igarashi Trousers</title>
      </MetaTags>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"寸法マスター"} breadcrumbList={[]} />

          <Card>
            <CardBody>
              {store.dimension.detail.loading ? (
                <LoadingComponent />
              ) : (
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Row>
                    <Col md={8}>
                      <p className="fw-bold">
                        {params.id != "add"
                          ? "寸法マスター詳細"
                          : "新規寸法マスター追加"}
                      </p>
                    </Col>
                    <Col className="d-flex justify-content-end">
                      <Button
                        color="primary"
                        type="submit"
                        className="button me-2"
                      >
                        保存
                      </Button>
                      <br />
                      <Button
                        color="warning"
                        type="button"
                        className="button"
                        onClick={() => history.push("/master/dimension")}
                      >
                        キャンセル
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="8">
                      <FormGroup row>
                        <Label sm="2">商品カテゴリー</Label>
                        <Col sm="6">
                          <Select
                            isLoading={
                              store.dimension.dimensionCategory.loading
                            }
                            options={store.dimension.dimensionCategory.data.map(
                              i => ({ value: i, label: i })
                            )}
                            defaultValue={{
                              value: validation.values.categoryName,
                              label: validation.values.categoryName,
                            }}
                            value={{
                              value: validation.values.categoryName,
                              label: validation.values.categoryName,
                            }}
                            onChange={e => {
                              validation.setFieldValue("categoryName", e.value)
                            }}
                          />
                          <Input
                            name="categoryName"
                            className="form-control d-none"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.categoryName || ""}
                            invalid={
                              validation.touched.categoryName &&
                              validation.errors.categoryName
                                ? true
                                : false
                            }
                          />
                          {validation.touched.categoryName &&
                          validation.errors.categoryName ? (
                            <FormFeedback type="invalid">
                              {validation.errors.categoryName}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label sm="2">項目</Label>
                        <Col sm="6">
                          <Input
                            name="item"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.item || ""}
                            invalid={
                              validation.touched.item && validation.errors.item
                                ? true
                                : false
                            }
                          />
                          {validation.touched.item && validation.errors.item ? (
                            <FormFeedback type="invalid">
                              {validation.errors.item}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                      <FormGroup row>
                        <Label sm="2">形式</Label>
                        <Col sm="6">
                          {/* <Select
                            options={['ラジオボタン', 'プルダウン', 'チェックボックス', 'TEXT'].map(i => ({ value: i, label: i }))}
                            defaultValue={{
                              value: validation.values.format,
                              label: validation.values.format
                            }}
                            value={{
                              value: validation.values.format,
                              label: validation.values.format
                            }}

                            onChange={e => {
                              validation.setFieldValue('format', e.value)
                            }}
                          /> */}
                          <Input
                            name="format"
                            className="form-control"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.format || ""}
                            invalid={
                              validation.touched.format &&
                              validation.errors.format
                                ? true
                                : false
                            }
                            disabled
                          />
                          {validation.touched.format &&
                          validation.errors.format ? (
                            <FormFeedback type="invalid">
                              {validation.errors.format}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label sm="2">枠種類</Label>
                        <Col sm="6">
                          <Select
                            isLoading={store.dimension.frameType.loading}
                            options={store.dimension.frameType.data.map(i => ({
                              value: i,
                              label: i,
                            }))}
                            defaultValue={{
                              value: validation.values.frameType,
                              label: validation.values.frameType,
                            }}
                            value={{
                              value: validation.values.frameType,
                              label: validation.values.frameType,
                            }}
                            onChange={e => {
                              validation.setFieldValue("frameType", e.value)
                            }}
                          />
                          <Input
                            name="frameType"
                            className="form-control d-none"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.frameType || ""}
                            invalid={
                              validation.touched.frameType &&
                              validation.errors.frameType
                                ? true
                                : false
                            }
                          />
                          {validation.touched.frameType &&
                          validation.errors.frameType ? (
                            <FormFeedback type="invalid">
                              {validation.errors.frameType}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}
